



















import {Component, Prop} from 'vue-property-decorator'
import Card from './proxy/Card/Card.vue'
import Container from './proxy/Container.vue'
import Layout from './proxy/Layout.vue'
import Flex from './proxy/Flex.vue'
import Avatar from './proxy/Avatar.vue'
import Icon from './proxy/Icon.vue'
import CustomIcon from './CustomIcon.vue'
import VuetifyColorHelper from '@/lib/vuetify/VuetifyColorHelper'
import ColorHelper from '@/lib/ColorHelper'

@Component({
  components: {
    CustomIcon,
    Card,
    Container,
    Layout,
    Flex,
    Avatar,
    Icon,
  },
})
export default class CardButton extends Card {
  @Prop({}) public circleColor?: string
  @Prop({}) public icon?: string
  @Prop({}) public iconColor?: string
  @Prop({}) public tile?: boolean
  @Prop({
    type: Boolean,
    default: true,
  }) public ripple?: boolean
  @Prop({
    type: Boolean,
    default: false,
  }) public flat?: boolean
  @Prop({
    type: Boolean,
    default: false,
  }) public wrap?: boolean
  @Prop({}) public action?: string
  @Prop({}) public description?: string
  public themeClasses: any

  public get isLight() {
    if (this.circleColor) {
      const override = this.$vuetify.theme.buttonDefaultColorOverride as string | undefined
      return ColorHelper.lightContrast(VuetifyColorHelper.color(this.circleColor))
    }
    return this.themeClasses['theme--light']
  }
}
